import {Catalogo} from '../models/catalogo';

export class Articolo {
    Id: number;
    Catalogo: Catalogo;
    Codicecatalogo: number;
    Codicearticolo: string;
    Descrizione: string;
    Categoria: string;
    Unitamisura: string
    Prezzo: number;
    Note: string;
  	Giacenza: number;
    Picbyte: any;
    Costo: number;
    Iva: number;
    Quantitarichiesta: number
  constructor(){
    this.Id=0;
    this.Catalogo=new Catalogo();
    this.Codicecatalogo=0;
    this.Codicearticolo='';
    this.Descrizione='';
    this.Categoria='';
    this.Unitamisura='';
    this.Prezzo=0;
    this.Note='';
  	this.Giacenza=0;
    this.Picbyte=null;
    this.Costo=0;
    this.Iva=0;
    this.Quantitarichiesta=0;
  }
}
